import { AutoFilterBreezeListComponent } from '@common/classes/auto-filter-list';
import { CurrencyCodes } from '@common/classes/codes';
import { AppGridComponent } from '@common/components/app-grid/app-grid.component';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { SharedService } from '@common/services/shared.service';
import { startOfMonth } from 'date-fns';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@common/services/breeze-view.service";
import * as i2 from "@common/services/shared.service";
import * as i3 from "@angular/common";
import * as i4 from "@angular/forms";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "@fortawesome/angular-fontawesome";
import * as i7 from "@progress/kendo-angular-grid";
import * as i8 from "../../../common/components/action-bar/action-bar.component";
import * as i9 from "../../../common/components/app-control/app-control.component";
import * as i10 from "../../../common/components/app-form/app-form.component";
import * as i11 from "../../../common/components/content-header/content-header.component";
import * as i12 from "../../../common/components/app-grid/app-grid.component";
import * as i13 from "../../../common/components/app-control-container/app-control-container.component";
import * as i14 from "../../../common/components/accordion-header.component";
import * as i15 from "@ngx-translate/core";
function VoyageReportListComponent_ng_template_6_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\u00A0(", ctx_r31.numberOfActiveFilters, ")");
  }
}
function VoyageReportListComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-accordion-header", 32);
    i0.ɵɵlistener("panelChange", function VoyageReportListComponent_ng_template_6_Template_app_accordion_header_panelChange_0_listener() {
      i0.ɵɵrestoreView(_r33);
      const ctx_r32 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r32.handleFilterHighlighter(true));
    });
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵelement(2, "fa-icon", 33);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, VoyageReportListComponent_ng_template_6_span_5_Template, 2, 1, "span", 34);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const panel_r30 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("panel", panel_r30);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" \u00A0", i0.ɵɵpipeBind1(4, 3, "Filters"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.numberOfActiveFilters > 0);
  }
}
function VoyageReportListComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-form", 35);
    i0.ɵɵlistener("submit", function VoyageReportListComponent_ng_template_7_Template_app_form_submit_0_listener() {
      i0.ɵɵrestoreView(_r36);
      const ctx_r35 = i0.ɵɵnextContext();
      ctx_r35.search();
      return i0.ɵɵresetView(ctx_r35.onAutoFilterChange());
    });
    i0.ɵɵelementStart(1, "app-control-container", null, 36)(3, "div", 8)(4, "div", 37)(5, "div", 8)(6, "div", 38)(7, "app-control", 39);
    i0.ɵɵlistener("ngModelChange", function VoyageReportListComponent_ng_template_7_Template_app_control_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r37 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r37.filter.voyageNumbers = $event);
    });
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 38)(10, "app-control", 40);
    i0.ɵɵlistener("ngModelChange", function VoyageReportListComponent_ng_template_7_Template_app_control_ngModelChange_10_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r38 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r38.filter.statusIds = $event);
    });
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 38)(13, "app-control", 41);
    i0.ɵɵlistener("ngModelChange", function VoyageReportListComponent_ng_template_7_Template_app_control_ngModelChange_13_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r39 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r39.filter.customerId = $event);
    });
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(15, "div", 37)(16, "div", 8)(17, "div", 42)(18, "app-control", 43);
    i0.ɵɵlistener("ngModelChange", function VoyageReportListComponent_ng_template_7_Template_app_control_ngModelChange_18_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r40 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r40.filter.serviceDateFrom = $event);
    });
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "div", 42)(21, "app-control", 44);
    i0.ɵɵlistener("ngModelChange", function VoyageReportListComponent_ng_template_7_Template_app_control_ngModelChange_21_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r41 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r41.filter.serviceDateTo = $event);
    });
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(23, "div", 42)(24, "app-control", 45);
    i0.ɵɵlistener("ngModelChange", function VoyageReportListComponent_ng_template_7_Template_app_control_ngModelChange_24_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r42 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r42.filter.sentToErp = $event);
    });
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "div", 42)(27, "app-control", 46);
    i0.ɵɵlistener("ngModelChange", function VoyageReportListComponent_ng_template_7_Template_app_control_ngModelChange_27_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r43 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r43.filter.currencyId = $event);
    });
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(29, "div", 37)(30, "div", 8)(31, "div", 38)(32, "app-control", 47);
    i0.ɵɵlistener("ngModelChange", function VoyageReportListComponent_ng_template_7_Template_app_control_ngModelChange_32_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r44 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r44.filter.lineId = $event);
    });
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "div", 38)(35, "app-control", 48);
    i0.ɵɵlistener("ngModelChange", function VoyageReportListComponent_ng_template_7_Template_app_control_ngModelChange_35_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r45 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r45.filter.recipientId = $event);
    });
    i0.ɵɵpipe(36, "translate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(37, "div", 37)(38, "div", 8)(39, "div", 38)(40, "app-control", 49);
    i0.ɵɵlistener("ngModelChange", function VoyageReportListComponent_ng_template_7_Template_app_control_ngModelChange_40_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r46 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r46.filter.finalCustomerId = $event);
    });
    i0.ɵɵpipe(41, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(42, "div", 38)(43, "app-control", 50);
    i0.ɵɵlistener("ngModelChange", function VoyageReportListComponent_ng_template_7_Template_app_control_ngModelChange_43_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r47 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r47.filter.organizationUnitId = $event);
    });
    i0.ɵɵpipe(44, "translate");
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(45, "div", 51)(46, "div", 9)(47, "div", 52)(48, "button", 53);
    i0.ɵɵlistener("click", function VoyageReportListComponent_ng_template_7_Template_button_click_48_listener() {
      i0.ɵɵrestoreView(_r36);
      const ctx_r48 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r48.clearFilter());
    });
    i0.ɵɵelement(49, "fa-icon", 54);
    i0.ɵɵtext(50, " \u00A0 ");
    i0.ɵɵelementStart(51, "span", 55);
    i0.ɵɵtext(52);
    i0.ɵɵpipe(53, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(54, "button", 56);
    i0.ɵɵlistener("click", function VoyageReportListComponent_ng_template_7_Template_button_click_54_listener() {
      i0.ɵɵrestoreView(_r36);
      const ctx_r49 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r49.search());
    });
    i0.ɵɵelement(55, "fa-icon", 57);
    i0.ɵɵtext(56, " \u00A0 ");
    i0.ɵɵelementStart(57, "span", 55);
    i0.ɵɵtext(58);
    i0.ɵɵpipe(59, "translate");
    i0.ɵɵelementEnd()()()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(8, 37, "Voyage"));
    i0.ɵɵproperty("multiValue", true)("ngModel", ctx_r1.filter.voyageNumbers)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(11, 39, "Invoice Status"));
    i0.ɵɵproperty("multi", true)("ngModel", ctx_r1.filter.statusIds)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(14, 41, "Customer"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.customerId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(19, 43, "Service Date From"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.serviceDateFrom)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(22, 45, "Service Date To"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.serviceDateTo)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(25, 47, "Sent To Erp"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.sentToErp)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(28, 49, "Currency"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.currencyId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(33, 51, "Line"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.lineId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(36, 53, "Recipient"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.recipientId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(41, 55, "Final Customer"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.finalCustomerId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(44, 57, "Organization Unit"));
    i0.ɵɵproperty("ngModel", ctx_r1.filter.organizationUnitId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(53, 59, "Clear"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(59, 61, "Search"));
  }
}
function VoyageReportListComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "Voyage"));
  }
}
function VoyageReportListComponent_ng_template_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "Recipient"));
  }
}
function VoyageReportListComponent_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "Currency"));
  }
}
function VoyageReportListComponent_ng_template_23_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "Total"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" (", ctx_r50.euro, "): ");
  }
}
function VoyageReportListComponent_ng_template_23_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "Total"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" (", ctx_r51.dollar, "): ");
  }
}
function VoyageReportListComponent_ng_template_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_23_div_0_Template, 5, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_23_div_1_Template, 5, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r5.anyValue(ctx_r5.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.anyValue(ctx_r5.dollar));
  }
}
function VoyageReportListComponent_ng_template_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "Invoice Count"));
  }
}
function VoyageReportListComponent_ng_template_27_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r52.getTotal("invoiceCount", ctx_r52.euro));
  }
}
function VoyageReportListComponent_ng_template_27_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r53.getTotal("invoiceCount", ctx_r53.dollar));
  }
}
function VoyageReportListComponent_ng_template_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_27_div_0_Template, 3, 1, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_27_div_1_Template, 3, 1, "div", 34);
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r7.anyValue(ctx_r7.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.anyValue(ctx_r7.dollar));
  }
}
function VoyageReportListComponent_ng_template_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b", 58);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("ngbTooltip", i0.ɵɵpipeBind1(1, 2, "Price Without Analytics"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "Price WA"), " ");
  }
}
function VoyageReportListComponent_ng_template_31_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r54.getTotal("invoiceItemTotalPrice", ctx_r54.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_31_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r55.getTotal("invoiceItemTotalPrice", ctx_r55.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_31_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_31_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r9.anyValue(ctx_r9.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.anyValue(ctx_r9.dollar));
  }
}
function VoyageReportListComponent_ng_template_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "Manipulations"));
  }
}
function VoyageReportListComponent_ng_template_35_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r56.getTotal("manipulationTotalPrice", ctx_r56.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_35_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r57.getTotal("manipulationTotalPrice", ctx_r57.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_35_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_35_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r11.anyValue(ctx_r11.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.anyValue(ctx_r11.dollar));
  }
}
function VoyageReportListComponent_ng_template_38_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r58.getTotal("imdgTotalValue", ctx_r58.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_38_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r59.getTotal("imdgTotalValue", ctx_r59.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_38_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_38_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_38_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r12.anyValue(ctx_r12.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.anyValue(ctx_r12.dollar));
  }
}
function VoyageReportListComponent_ng_template_41_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r60.getTotal("overtimeTotalValue", ctx_r60.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_41_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r61.getTotal("overtimeTotalValue", ctx_r61.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_41_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_41_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_41_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r13.anyValue(ctx_r13.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.anyValue(ctx_r13.dollar));
  }
}
function VoyageReportListComponent_ng_template_44_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r62.getTotal("holidayTotalValue", ctx_r62.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_44_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r63 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r63.getTotal("holidayTotalValue", ctx_r63.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_44_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_44_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_44_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r14.anyValue(ctx_r14.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.anyValue(ctx_r14.dollar));
  }
}
function VoyageReportListComponent_ng_template_47_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r64 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r64.getTotal("oogTotalValue", ctx_r64.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_47_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r65 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r65.getTotal("oogTotalValue", ctx_r65.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_47_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_47_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_47_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r15.anyValue(ctx_r15.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.anyValue(ctx_r15.dollar));
  }
}
function VoyageReportListComponent_ng_template_50_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "Storage"));
  }
}
function VoyageReportListComponent_ng_template_51_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r66 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r66.getTotal("storageTotalPrice", ctx_r66.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_51_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r67 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r67.getTotal("storageTotalPrice", ctx_r67.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_51_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_51_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_51_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r17.anyValue(ctx_r17.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.anyValue(ctx_r17.dollar));
  }
}
function VoyageReportListComponent_ng_template_54_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r68.getTotal("storageSurchargeAmountPrice", ctx_r68.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_54_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r69 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r69.getTotal("storageSurchargeAmountPrice", ctx_r69.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_54_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_54_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_54_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r18.anyValue(ctx_r18.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.anyValue(ctx_r18.dollar));
  }
}
function VoyageReportListComponent_ng_template_57_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r70 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r70.getTotal("storageImdgTotalValue", ctx_r70.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_57_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r71.getTotal("storageImdgTotalValue", ctx_r71.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_57_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_57_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_57_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r19.anyValue(ctx_r19.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.anyValue(ctx_r19.dollar));
  }
}
function VoyageReportListComponent_ng_template_60_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b", 58);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("ngbTooltip", i0.ɵɵpipeBind1(1, 2, "Additional Work Vessel"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "AA Vessel"), " ");
  }
}
function VoyageReportListComponent_ng_template_61_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r72 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r72.getTotal("additionalWorkVesselTotalPrice", ctx_r72.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_61_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r73 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r73.getTotal("additionalWorkVesselTotalPrice", ctx_r73.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_61_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_61_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_61_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r21.anyValue(ctx_r21.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.anyValue(ctx_r21.dollar));
  }
}
function VoyageReportListComponent_ng_template_64_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b", 58);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("ngbTooltip", i0.ɵɵpipeBind1(1, 2, "Additional Work CNT"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "AA CNT"), " ");
  }
}
function VoyageReportListComponent_ng_template_65_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r74 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r74.getTotal("additionalWorkContainerTotalPrice", ctx_r74.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_65_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r75.getTotal("additionalWorkContainerTotalPrice", ctx_r75.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_65_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_65_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_65_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r23.anyValue(ctx_r23.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.anyValue(ctx_r23.dollar));
  }
}
function VoyageReportListComponent_ng_template_68_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "ISPS"));
  }
}
function VoyageReportListComponent_ng_template_69_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r76 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r76.getTotal("ispsTotalPrice", ctx_r76.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_69_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r77 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r77.getTotal("ispsTotalPrice", ctx_r77.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_69_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_69_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_69_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r25.anyValue(ctx_r25.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r25.anyValue(ctx_r25.dollar));
  }
}
function VoyageReportListComponent_ng_template_72_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "LLP"));
  }
}
function VoyageReportListComponent_ng_template_73_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r78 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r78.getTotal("llpTotalPrice", ctx_r78.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_73_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r79.getTotal("llpTotalPrice", ctx_r79.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_73_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_73_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_73_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r27.anyValue(ctx_r27.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r27.anyValue(ctx_r27.dollar));
  }
}
function VoyageReportListComponent_ng_template_76_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "Total"));
  }
}
function VoyageReportListComponent_ng_template_77_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r80.getTotal("totalPrice", ctx_r80.euro), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_77_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r81.getTotal("totalPrice", ctx_r81.dollar), "1.2"));
  }
}
function VoyageReportListComponent_ng_template_77_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VoyageReportListComponent_ng_template_77_div_0_Template, 4, 4, "div", 34);
    i0.ɵɵtemplate(1, VoyageReportListComponent_ng_template_77_div_1_Template, 4, 4, "div", 34);
  }
  if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r29.anyValue(ctx_r29.euro));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.anyValue(ctx_r29.dollar));
  }
}
const _c0 = function () {
  return {
    enabled: true,
    checkboxOnly: true
  };
};
const _c1 = function () {
  return {
    "summary-row": true
  };
};
const _c2 = function () {
  return {
    "text-align": "right"
  };
};
export class VoyageReportListComponent extends AutoFilterBreezeListComponent {
  constructor(breezeViewService, sharedService) {
    super(breezeViewService, sharedService);
    this.breezeViewService = breezeViewService;
    this.sharedService = sharedService;
    this.queryName = 'InvoiceVoyageSummary';
    this.parentRoute = '/invoice/';
    this.excelCommand = 'ExportInvoiceVoyageSummaryToExcel';
    this.gridSort = [{
      field: 'recipientName',
      dir: 'asc'
    }, {
      field: 'voyageNumber',
      dir: 'asc'
    }];
    this.euro = CurrencyCodes.Euro;
    this.dollar = CurrencyCodes.Dollar;
    this.actionGroup.isVisible = () => false;
  }
  search() {
    this.appGrid.isBusy = true;
    this.handleFilterHighlighter();
    return this.entityManager.executeQuery(this.getQuery()).then(data => {
      this.data = data.results;
    }).finally(() => {
      this.appGrid.isBusy = false;
    });
  }
  getDefaultFilter(data) {
    return this.breezeViewService.entityManager.createEntity('GetInvoiceVoyageSummaryQuery', {
      sentToErp: true,
      serviceDateFrom: startOfMonth(new Date()),
      ...data
    });
  }
  getTotal(property, currencyId) {
    return _.chain(this.appGrid.internalData.data).filter(x => x.currencyId === currencyId).sumBy(x => x[property]).value();
  }
  anyValue(currencyId) {
    return _.some(this.appGrid.internalData.data, x => x.currencyId === currencyId);
  }
}
VoyageReportListComponent.ɵfac = function VoyageReportListComponent_Factory(t) {
  return new (t || VoyageReportListComponent)(i0.ɵɵdirectiveInject(i1.BreezeViewService), i0.ɵɵdirectiveInject(i2.SharedService));
};
VoyageReportListComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: VoyageReportListComponent,
  selectors: [["app-voyage-report-list"]],
  viewQuery: function VoyageReportListComponent_Query(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵviewQuery(AppGridComponent, 5);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.appGrid = _t.first);
    }
  },
  features: [i0.ɵɵProvidersFeature([BreezeViewService]), i0.ɵɵInheritDefinitionFeature],
  decls: 78,
  vars: 150,
  consts: [[3, "items"], [3, "title"], [1, "filter-wrapper"], ["activeIds", "ngb-panel-0"], ["ngbPanelHeader", ""], ["ngbPanelContent", ""], [1, "card", "card-border-top", "mt-3"], [1, "card-body"], [1, "row"], [1, "col"], [1, "mb-2", "voyage-summary-table", 3, "pageable", "data", "sortable", "sort", "selectable", "selection", "selectionChange"], ["showSelectAll", "true", 3, "width", "footerClass"], ["field", "voyageNumber", 3, "title", "footerClass"], ["kendoGridHeaderTemplate", ""], ["field", "recipientName", 3, "title", "footerClass"], ["field", "currencyId", 3, "title", "footerClass"], ["kendoGridFooterTemplate", ""], ["field", "invoiceCount", 3, "title", "format", "footerClass"], ["format", "n2", "field", "invoiceItemTotalPrice", 3, "title", "footerClass"], ["format", "n2", "field", "manipulationTotalPrice", 3, "title", "footerClass"], ["format", "n2", "field", "imdgTotalValue", 3, "title", "footerClass"], ["format", "n2", "field", "overtimeTotalValue", 3, "title", "footerClass"], ["format", "n2", "field", "holidayTotalValue", 3, "title", "footerClass"], ["format", "n2", "field", "oogTotalValue", 3, "title", "footerClass"], ["format", "n2", "field", "storageTotalPrice", 3, "title", "footerClass"], ["format", "n2", "field", "storageSurchargeAmountPrice", 3, "title", "footerClass"], ["format", "n2", "field", "storageImdgTotalValue", 3, "title", "footerClass"], ["format", "n2", "field", "additionalWorkVesselTotalPrice", 3, "title", "footerClass"], ["format", "n2", "field", "additionalWorkContainerTotalPrice", 3, "title", "footerClass"], ["format", "n2", "field", "ispsTotalPrice", 3, "title", "footerClass"], ["format", "n2", "field", "llpTotalPrice", 3, "title", "footerClass"], ["format", "n2", "field", "totalPrice", 3, "title", "footerClass"], [3, "panel", "panelChange"], ["icon", "filter"], [4, "ngIf"], [3, "submit"], ["filterHighlighter", ""], [1, "col-3"], [1, "col-12"], ["property", "voyageNumbers", 3, "label", "multiValue", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "InvoiceStatus", "property", "statusIds", 3, "label", "multi", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Customer", "property", "customerId", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "col-6"], ["property", "serviceDateFrom", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "serviceDateTo", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "sentToErp", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Currency", "property", "currencyId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Line", "property", "lineId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Customer", "property", "recipientId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Customer", "property", "finalCustomerId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "OrganizationUnit", "property", "organizationUnitId", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "row", "mt-3"], [1, "float-right"], [1, "btn", "btn-sm", "btn-danger", "mr-2", 3, "click"], ["icon", "trash", 1, "ml-1"], [1, "btn-text"], [1, "btn", "btn-sm", "btn-primary", 3, "click"], ["icon", "search", 1, "ml-1"], ["placement", "bottom", 3, "ngbTooltip"]],
  template: function VoyageReportListComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelement(0, "app-action-bar", 0)(1, "app-content-header", 1);
      i0.ɵɵpipe(2, "translate");
      i0.ɵɵelementStart(3, "div", 2)(4, "ngb-accordion", 3)(5, "ngb-panel");
      i0.ɵɵtemplate(6, VoyageReportListComponent_ng_template_6_Template, 6, 5, "ng-template", 4);
      i0.ɵɵtemplate(7, VoyageReportListComponent_ng_template_7_Template, 60, 63, "ng-template", 5);
      i0.ɵɵelementEnd()()();
      i0.ɵɵelementStart(8, "div", 6)(9, "div", 7)(10, "div", 8)(11, "div", 9)(12, "app-grid", 10);
      i0.ɵɵlistener("selectionChange", function VoyageReportListComponent_Template_app_grid_selectionChange_12_listener($event) {
        return ctx.selection = $event;
      });
      i0.ɵɵelement(13, "kendo-grid-checkbox-column", 11);
      i0.ɵɵelementStart(14, "kendo-grid-column", 12);
      i0.ɵɵpipe(15, "translate");
      i0.ɵɵtemplate(16, VoyageReportListComponent_ng_template_16_Template, 3, 3, "ng-template", 13);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(17, "kendo-grid-column", 14);
      i0.ɵɵpipe(18, "translate");
      i0.ɵɵtemplate(19, VoyageReportListComponent_ng_template_19_Template, 3, 3, "ng-template", 13);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(20, "kendo-grid-column", 15);
      i0.ɵɵpipe(21, "translate");
      i0.ɵɵtemplate(22, VoyageReportListComponent_ng_template_22_Template, 3, 3, "ng-template", 13);
      i0.ɵɵtemplate(23, VoyageReportListComponent_ng_template_23_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(24, "kendo-grid-column", 17);
      i0.ɵɵpipe(25, "translate");
      i0.ɵɵtemplate(26, VoyageReportListComponent_ng_template_26_Template, 3, 3, "ng-template", 13);
      i0.ɵɵtemplate(27, VoyageReportListComponent_ng_template_27_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(28, "kendo-grid-column", 18);
      i0.ɵɵpipe(29, "translate");
      i0.ɵɵtemplate(30, VoyageReportListComponent_ng_template_30_Template, 4, 6, "ng-template", 13);
      i0.ɵɵtemplate(31, VoyageReportListComponent_ng_template_31_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(32, "kendo-grid-column", 19);
      i0.ɵɵpipe(33, "translate");
      i0.ɵɵtemplate(34, VoyageReportListComponent_ng_template_34_Template, 3, 3, "ng-template", 13);
      i0.ɵɵtemplate(35, VoyageReportListComponent_ng_template_35_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(36, "kendo-grid-column", 20);
      i0.ɵɵpipe(37, "translate");
      i0.ɵɵtemplate(38, VoyageReportListComponent_ng_template_38_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(39, "kendo-grid-column", 21);
      i0.ɵɵpipe(40, "translate");
      i0.ɵɵtemplate(41, VoyageReportListComponent_ng_template_41_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(42, "kendo-grid-column", 22);
      i0.ɵɵpipe(43, "translate");
      i0.ɵɵtemplate(44, VoyageReportListComponent_ng_template_44_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(45, "kendo-grid-column", 23);
      i0.ɵɵpipe(46, "translate");
      i0.ɵɵtemplate(47, VoyageReportListComponent_ng_template_47_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(48, "kendo-grid-column", 24);
      i0.ɵɵpipe(49, "translate");
      i0.ɵɵtemplate(50, VoyageReportListComponent_ng_template_50_Template, 3, 3, "ng-template", 13);
      i0.ɵɵtemplate(51, VoyageReportListComponent_ng_template_51_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(52, "kendo-grid-column", 25);
      i0.ɵɵpipe(53, "translate");
      i0.ɵɵtemplate(54, VoyageReportListComponent_ng_template_54_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(55, "kendo-grid-column", 26);
      i0.ɵɵpipe(56, "translate");
      i0.ɵɵtemplate(57, VoyageReportListComponent_ng_template_57_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(58, "kendo-grid-column", 27);
      i0.ɵɵpipe(59, "translate");
      i0.ɵɵtemplate(60, VoyageReportListComponent_ng_template_60_Template, 4, 6, "ng-template", 13);
      i0.ɵɵtemplate(61, VoyageReportListComponent_ng_template_61_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(62, "kendo-grid-column", 28);
      i0.ɵɵpipe(63, "translate");
      i0.ɵɵtemplate(64, VoyageReportListComponent_ng_template_64_Template, 4, 6, "ng-template", 13);
      i0.ɵɵtemplate(65, VoyageReportListComponent_ng_template_65_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(66, "kendo-grid-column", 29);
      i0.ɵɵpipe(67, "translate");
      i0.ɵɵtemplate(68, VoyageReportListComponent_ng_template_68_Template, 3, 3, "ng-template", 13);
      i0.ɵɵtemplate(69, VoyageReportListComponent_ng_template_69_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(70, "kendo-grid-column", 30);
      i0.ɵɵpipe(71, "translate");
      i0.ɵɵtemplate(72, VoyageReportListComponent_ng_template_72_Template, 3, 3, "ng-template", 13);
      i0.ɵɵtemplate(73, VoyageReportListComponent_ng_template_73_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(74, "kendo-grid-column", 31);
      i0.ɵɵpipe(75, "translate");
      i0.ɵɵtemplate(76, VoyageReportListComponent_ng_template_76_Template, 3, 3, "ng-template", 13);
      i0.ɵɵtemplate(77, VoyageReportListComponent_ng_template_77_Template, 2, 2, "ng-template", 16);
      i0.ɵɵelementEnd()()()()()();
    }
    if (rf & 2) {
      i0.ɵɵproperty("items", ctx.actionBar);
      i0.ɵɵadvance(1);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 77, "Voyage Number Report"));
      i0.ɵɵadvance(11);
      i0.ɵɵproperty("pageable", false)("data", ctx.data)("sortable", true)("sort", ctx.gridSort)("selectable", i0.ɵɵpureFunction0(115, _c0))("selection", ctx.selection);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("width", 1)("footerClass", i0.ɵɵpureFunction0(116, _c1));
      i0.ɵɵadvance(1);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(15, 79, "Voyage"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(117, _c1));
      i0.ɵɵadvance(3);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(18, 81, "Recipient"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(118, _c1));
      i0.ɵɵadvance(3);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(21, 83, "Currency"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(119, _c1));
      i0.ɵɵadvance(4);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(120, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(25, 85, "Invoice Count"));
      i0.ɵɵproperty("format", "#")("footerClass", i0.ɵɵpureFunction0(121, _c1));
      i0.ɵɵadvance(4);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(122, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(29, 87, "Price WA"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(123, _c1));
      i0.ɵɵadvance(4);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(124, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(33, 89, "Manipulations"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(125, _c1));
      i0.ɵɵadvance(4);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(126, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(37, 91, "IMDG"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(127, _c1));
      i0.ɵɵadvance(3);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(128, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(40, 93, "Overtime"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(129, _c1));
      i0.ɵɵadvance(3);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(130, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(43, 95, "Holiday"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(131, _c1));
      i0.ɵɵadvance(3);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(132, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(46, 97, "OOG"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(133, _c1));
      i0.ɵɵadvance(3);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(134, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(49, 99, "Storage"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(135, _c1));
      i0.ɵɵadvance(4);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(136, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(53, 101, "CNT Type"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(137, _c1));
      i0.ɵɵadvance(3);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(138, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(56, 103, "IMDG"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(139, _c1));
      i0.ɵɵadvance(3);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(140, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(59, 105, "AA Vessel"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(141, _c1));
      i0.ɵɵadvance(4);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(142, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(63, 107, "AA CNT"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(143, _c1));
      i0.ɵɵadvance(4);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(144, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(67, 109, "ISPS"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(145, _c1));
      i0.ɵɵadvance(4);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(146, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(71, 111, "LLP"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(147, _c1));
      i0.ɵɵadvance(4);
      i0.ɵɵstyleMap(i0.ɵɵpureFunction0(148, _c2));
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(75, 113, "Total"));
      i0.ɵɵproperty("footerClass", i0.ɵɵpureFunction0(149, _c1));
    }
  },
  dependencies: [i3.NgIf, i4.NgControlStatus, i4.NgModel, i5.NgbAccordion, i5.NgbPanel, i5.NgbPanelContent, i5.NgbPanelHeader, i5.NgbTooltip, i6.FaIconComponent, i7.ColumnComponent, i7.FooterTemplateDirective, i7.CheckboxColumnComponent, i7.HeaderTemplateDirective, i8.ActionBarComponent, i9.AppControlComponent, i10.AppFormComponent, i11.ContentHeaderComponent, i12.AppGridComponent, i13.AppControlContainerComponent, i14.AccordionHeaderComponent, i3.DecimalPipe, i15.TranslatePipe],
  styles: ["\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZVJvb3QiOiIifQ== */"]
});